import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate(); // Initialize navigate function

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const handleGetInvolvedClick = () => {
    navigate('/getinvolved'); // Navigate to '/getinvolved' when the button is clicked
  };

  return (
    <section className="h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 bg-[url('../src/assets/img/Home/Cover.webp')] bg-cover bg-center bg-no-repeat" />

      {/* Black Overlay */}
      <div className="absolute inset-0 bg-black opacity-[.58]" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 text-white">
        <h1
          className="text-xl md:text-2xl font-light uppercase mt-2 tracking-wider font-playfair animate-fade-up"
          style={{ animationDelay: '0.2s' }}
        >
          "He has scattered abroad his gifts to the poor
        </h1>
        <h2
          className="text-3xl md:text-4xl lg:text-4xl font-bold uppercase mt-4 p-4 bg-black bg-opacity-60 tracking-wider shadow-lg inline-block font-playfair animate-fade-up"
          style={{ animationDelay: '0.4s' }}
        >
          his righteousness endures forever"
        </h2>
        <p
          className="mt-2 text-base md:text-lg italic font-playfair animate-fade-up"
          style={{ animationDelay: '0.6s' }}
        >
          2 Corinthians 9:9
        </p>
      </div>

      <div className="absolute -bottom-16 md:w-[70%] w-[90%]  h-32 bg-[#90444D] bg-opacity-80 flex items-center pl-4 space-x-4">
        {/* Date Section */}
        <div className="text-white flex items-center justify-center w-1/8">
          <h1 className="text-lg font-semibold text-center font-playfair">{formattedDate}</h1>
        </div>

        {/* Info & Button Section */}
        <div className="bg-white flex items-center justify-between w-full h-32 px-4 rounded-tl-xl mt-8 border border-gray-200">
          <p className="text-lg hidden md:block font-playfair">
            CCCEA is Non-Governmental Organization for <span className='uppercase'>children and elders</span>
          </p>
          <button
            className="px-4 py-2 font-playfair bg-customGreen text-white rounded hover:bg-cyan-800 transition duration-200"
            onClick={handleGetInvolvedClick} // Use handleGetInvolvedClick
          >
            Get Involved Today
          </button>
        </div>
      </div>


    </section>
  );
};

export default Home;
